/**
 * Pure formatting + validation for the notification threshold inputs, extracted
 * so the branching logic is unit-testable without rendering the form.
 *
 * `lowBalanceThreshold` is a dollar amount (≥ 0); `creditUtilizationThreshold`
 * is a whole-number percent in (0, 100] — mirroring the backend validation in
 * `FamilyController.updateSettings`.
 */

export const formatDollars = (value: number | null | undefined): string => (value != null ? value.toFixed(2) : '');

export const formatPercent = (value: number | null | undefined): string => (value != null ? String(value) : '');

export const validateDollars = (value: string): string | undefined => {
  if (!value) {
    return 'Low balance threshold is required';
  }
  const num = parseFloat(value);
  if (isNaN(num)) {
    return 'Please enter a valid number';
  }
  if (num < 0) {
    return 'Threshold must be a positive number';
  }
  return undefined;
};

export const validatePercent = (value: string): string | undefined => {
  if (!value) {
    return 'Credit utilization threshold is required';
  }
  const num = Number(value);
  if (isNaN(num) || !Number.isInteger(num)) {
    return 'Enter a whole number';
  }
  if (num <= 0 || num > 100) {
    return 'Enter a percent between 1 and 100';
  }
  return undefined;
};
